import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ProjectVersion} from "./projectVersionDomain";
import {ID} from "../../../core/metamodel/metaConstant";


@entityConfig()
export default class ProjectVersionParking extends DomainAncestor {

  @observable parkingId : number;
  @observable projectVersion : ProjectVersion;
  @observable parkingName : string;
  @observable value : number;
  @observable controlledCo : boolean;
  @observable chargingStations : boolean;
  @observable carsharing : boolean;


  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.parkingId;
  }

  public setId(id: ID): void {
    this.parkingId = <number>id;
  }

}



// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectVersionParkingDomain.ts